var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#EAEFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_436_9835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 15.5C21.933 15.5 23.5 13.933 23.5 12C23.5 10.067 21.933 8.5 20 8.5C18.067 8.5 16.5 10.067 16.5 12C16.5 13.933 18.067 15.5 20 15.5Z",
    fill: "#0236C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4043 18.551C23.9953 17.324 22.8513 16.5 21.5583 16.5H18.4413C17.1483 16.5 16.0043 17.324 15.5953 18.551L13.0513 26.183C12.9493 26.488 13.0013 26.823 13.1893 27.084C13.3773 27.345 13.6793 27.499 14.0003 27.499H16.0003V31.499C16.0003 32.051 16.4483 32.499 17.0003 32.499H23.0003C23.5523 32.499 24.0003 32.051 24.0003 31.499V27.499H26.0003C26.3213 27.499 26.6233 27.345 26.8113 27.084C26.9993 26.823 27.0503 26.488 26.9493 26.183L24.4043 18.551Z",
    fill: "#0236C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_436_9835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.19753bf5f85b34e226944819347bab4b.svg";
export { ForwardRef as ReactComponent };